import { PAGE_SIZES } from '@/lib/warehouse/url-state'

export function pageRange(page: number, pageSize: number, total: number): string {
  if (total === 0) return '0'
  const first = (page - 1) * pageSize + 1
  return `${first.toLocaleString('ru-RU')}–${Math.min(total, first + pageSize - 1).toLocaleString('ru-RU')}`
}

type OffsetPaginationProps = {
  mode?: 'offset'
  page: number
  pageSize: number
  total: number
  noun?: string
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
}

type CursorPaginationProps = {
  mode: 'cursor'
  pageToken: string | null
  nextPageToken: string | null
  onPageTokenChange: (pageToken: string) => void
  loading?: boolean
  noun?: string
  nextLabel?: string
}

export function Pagination(props: OffsetPaginationProps | CursorPaginationProps) {
  if (props.mode === 'cursor') {
    const nextPageToken = props.nextPageToken
    return (
      <nav aria-label="Постраничная навигация" className="mt-3 flex flex-wrap items-center justify-end gap-3 text-xs text-ink-2">
        <span>{nextPageToken ? `Есть ещё ${props.noun ?? 'записей'}` : `Все ${props.noun ?? 'записи'} показаны`}</span>
        {nextPageToken ? <button type="button" className="btn btn-ghost h-8" disabled={props.loading} onClick={() => props.onPageTokenChange(nextPageToken)}>{props.loading ? 'Загружаем…' : props.nextLabel ?? 'Вперёд'}</button> : null}
      </nav>
    )
  }

  const { page, pageSize, total, noun = 'товаров', onPageChange, onPageSizeChange } = props
  const pageCount = Math.max(1, Math.ceil(total / pageSize))
  return (
    <nav aria-label="Постраничная навигация" className="mt-3 flex flex-wrap items-center justify-between gap-3 text-xs text-ink-2">
      <span>Найдено {total.toLocaleString('ru-RU')} {noun} · показано {pageRange(page, pageSize, total)}</span>
      <div className="flex items-center gap-2">
        <label className="text-ink-muted">
          На странице
          <select
            aria-label="Строк на странице"
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
            className="ml-1 h-8 rounded-md border border-rule bg-white px-2"
          >
            {PAGE_SIZES.map((size) => <option key={size}>{size}</option>)}
          </select>
        </label>
        <button type="button" className="btn btn-ghost h-8" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>Назад</button>
        <span>Страница {page} из {pageCount}</span>
        <button type="button" className="btn btn-ghost h-8" disabled={page >= pageCount} onClick={() => onPageChange(page + 1)}>Вперёд</button>
      </div>
    </nav>
  )
}
